import { Select, Table } from "antd";
import styles from "./index.module.scss";
import './index.scss';

interface CategoryTableCardProps {
  icon: React.ReactNode;
  title: string;
  selectOptions: any;
  selectedItems?: string[];
  totalEntries: number;
  approvedEntries?: number;
  selectedUserQcCount?: number;
  onSelectChange: (value: string[], option: any) => void;
  columns: any[];
  data: any[];
}

const DashboardSelectorCard = ({
  icon,
  title,
  selectOptions,
  selectedItems,
  totalEntries,
  approvedEntries,
  selectedUserQcCount,
  onSelectChange,
  columns,
  data,
}: CategoryTableCardProps) => {
  // Calculate if we need scroll based on data length
  // Show scroll only if there are more than 3 rows
  const needsScroll = data.length > 3;
  const scrollHeight = needsScroll ? 150 : undefined;

  return (
    <div className={styles["category-card"]}>
      <div className={styles["category-card__title"]}>
        {icon}
        <div>{title}</div>
      </div>

      <div className={styles["category-card__select"]}>
        <Select
          mode="multiple"
          allowClear
          style={{ width: "200px" }}
          placeholder="Please select"
          options={selectOptions}
          onChange={onSelectChange}
          value={selectedItems}
          className="custom-select"
          optionFilterProp="label"
        />
        <div className={styles["category-card__select-label"]}>
          Selected
          <span className={styles["category-card__select-label--number"]}>
            [{selectedItems && selectedItems.length}]
          </span>
          :{" "}
          <span className={styles["category-card__select-label--count"]}>
            {totalEntries}
          </span>{" "}
          entries {title === 'Users' && <>
            (Approved: <span className={styles["category-card__select-label--count"]}>
              {approvedEntries}
            </span>)</>}
        </div>
      </div>

      <div className={styles["category-card__table"]}>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          size="middle"
          bordered
          scroll={scrollHeight ? { y: scrollHeight } : undefined}
          rowClassName={(record: any) => {
            return selectedItems?.includes(record.key) ? styles["row-highlight"] : ""
          }}
        />
      </div>
    </div>
  );
};

export default DashboardSelectorCard;
